var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickerOptional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 298,
    viewBox: "0 0 227 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.467 203.467C163.172 203.467 203.467 163.172 203.467 113.467C203.467 63.761 163.172 23.4667 113.467 23.4667C63.7609 23.4667 23.4666 63.761 23.4666 113.467C23.4666 163.172 63.7609 203.467 113.467 203.467Z",
    fill: "url(#paint0_linear_275_60)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.728 83.7307L149.513 83.5158C145.185 79.1877 138.125 79.1877 133.797 83.5158L97.6371 119.675L89.1651 111.203C84.7756 106.814 77.6542 106.814 73.234 111.203C68.8445 115.593 68.8445 122.714 73.234 127.134L89.5642 143.465L89.779 143.679C94.1071 148.008 101.167 148.008 105.495 143.679L105.587 143.587L149.697 99.4776C154.025 95.1495 154.025 88.0894 149.697 83.7613L149.728 83.7307Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0193 274.391V240.337H23.4668V232.8H53.0557V240.337H42.6708V274.391H34.0168H34.0193Z",
    fill: "#2D0909"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2177 274.391C83.1662 274.391 80.4191 273.692 77.9841 272.297C75.5465 270.901 73.6093 268.995 72.1777 266.575C70.7436 264.156 70.0291 261.44 70.0291 258.424C70.0291 255.409 70.7358 252.703 72.1494 250.302C73.5629 247.9 75.5001 246.012 77.9557 244.635C80.4113 243.257 83.1662 242.568 86.2177 242.568C88.4876 242.568 90.5899 242.961 92.527 243.74C94.4616 244.521 96.1176 245.61 97.4951 247.005C98.8725 248.401 99.8578 250.049 100.454 251.945L93.1951 255.071C92.6741 253.547 91.7893 252.337 90.5434 251.442C89.295 250.549 87.8531 250.103 86.2177 250.103C84.7655 250.103 83.4732 250.456 82.3382 251.163C81.2032 251.87 80.3082 252.858 79.6581 254.122C79.0055 255.388 78.6805 256.838 78.6805 258.476C78.6805 260.114 79.0055 261.566 79.6581 262.83C80.3082 264.097 81.2032 265.082 82.3382 265.789C83.4732 266.495 84.768 266.849 86.2177 266.849C87.8918 266.849 89.344 266.403 90.5718 265.51C91.7996 264.618 92.6741 263.408 93.1951 261.881L100.454 265.064C99.8965 266.851 98.9266 268.451 97.5518 269.864C96.1744 271.28 94.5184 272.387 92.5838 273.187C90.6492 273.986 88.5263 274.386 86.2203 274.386L86.2177 274.391Z",
    fill: "#2D0909"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.727 242.576H125.399L113.74 254.88V232.8H105.364V274.391H113.74V265.061L117.106 261.393L124.849 274.391H134.339L123.34 256.193L135.727 242.576Z",
    fill: "#2D0909"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.159 242.579C152.038 242.579 150.204 243.035 148.659 243.946C147.486 244.64 146.565 245.813 145.897 247.462V242.568H138.081V274.391H146.454V256.982C146.454 254.713 147.086 252.953 148.352 251.707C149.616 250.462 151.275 249.837 153.32 249.837H155.944V242.579H154.156H154.159Z",
    fill: "#2D0909"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1152 242.571H56.7397V274.394H65.1152V242.571Z",
    fill: "#2D0909"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1152 232.8H56.7397V240.337H65.1152V232.8Z",
    fill: "#2D0909"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.751 274.475H185.844L181.632 262.206H167.97L163.758 274.475H157.903L172.335 232.828H177.318L191.751 274.475ZM200.029 274.465H195.259V247.399H200.029V274.465ZM169.921 256.635H179.732L174.904 240.707H174.801L169.921 256.635ZM197.325 233.203C197.421 232.689 198.091 232.689 198.187 233.203C198.85 236.755 199.873 237.876 203.115 238.602C203.584 238.707 203.584 239.442 203.115 239.547C199.872 240.273 198.85 241.394 198.187 244.947C198.091 245.46 197.421 245.46 197.325 244.947C196.662 241.394 195.639 240.273 192.397 239.547C191.928 239.442 191.928 238.707 192.397 238.602C195.639 237.876 196.662 236.755 197.325 233.203Z",
    fill: "url(#paint1_linear_275_60)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_275_60",
    x1: 49.8035,
    y1: 49.8343,
    x2: 177.099,
    y2: 177.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A72B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_275_60",
    x1: 157.903,
    y1: 232.828,
    x2: 203.968,
    y2: 273.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235577,
    stopColor: "#FDC80E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "#9898FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846154,
    stopColor: "#EB513B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickerOptional);
export default __webpack_public_path__ + "static/media/TickerOptional.34e058471a1e801cefcdbf331e4ba8ee.svg";
export { ForwardRef as ReactComponent };